/**
 * JNP auto reveal-on-scroll for sections.
 *
 * The theme only applies the built-in `scroll-trigger animate--slide-in`
 * classes to a handful of standard Dawn sections (footer, contact, etc.).
 * The homepage and most pages use custom + Blocky sections that never got
 * tagged, so they don't reveal on scroll.
 *
 * This script tags every content section inside <main> at runtime and runs
 * its own IntersectionObserver, reusing the theme's existing CSS classes
 * (scroll-trigger / scroll-trigger--offscreen / animate--slide-in) so the
 * visual result matches the native reveal.
 *
 * Tier 3 custom file — touches no upstream Dawn/Blocky section.
 *
 * Progressive enhancement: the hiding class is added by JS, never in Liquid,
 * so if JS is disabled or fails, all sections simply render normally.
 *
 * Skipped automatically:
 *  - prefers-reduced-motion visitors and the Shopify theme editor
 *  - header / popup / announcement / marquee / slideshow sections
 *  - sections already above the fold on load (avoids a hero flash)
 *  - sections that already contain a .scroll-trigger element (Dawn sections)
 */
(function () {
  'use strict';

  // Section id keywords that should never slide in.
  var SKIP = /header|popup|announcement|marquee|scrolling-text|slideshow|breadcrumb/i;

  function init() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.Shopify && window.Shopify.designMode) return;

    var main = document.getElementById('MainContent');
    if (!main) return;

    var sections = main.querySelectorAll(':scope > .shopify-section');
    var foldLine = window.innerHeight * 0.85;
    var toObserve = [];

    sections.forEach(function (section) {
      if (SKIP.test(section.id)) return; // header / popup / marquee / etc.
      if (section.classList.contains('scroll-trigger')) return; // already tagged
      if (section.querySelector('.scroll-trigger')) return; // Dawn section animates internally
      if (section.getBoundingClientRect().top < foldLine) return; // above the fold

      section.classList.add('scroll-trigger', 'animate--slide-in', 'scroll-trigger--offscreen');
      section.setAttribute('data-cascade', '');
      toObserve.push(section);
    });

    if (toObserve.length === 0) return;

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry, index) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          el.style.setProperty('--animation-order', index);
          el.classList.remove('scroll-trigger--offscreen');
          obs.unobserve(el);
        });
      },
      { rootMargin: '0px 0px -50px 0px' }
    );

    toObserve.forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
